// Stable per-browser anonymous id. Generated synchronously on first import
// so concurrent requests at app boot all carry the same value. This is what
// makes anonymous activity_log rows group correctly — relying on a
// server-issued cookie loses the race when multiple requests fire before
// the first Set-Cookie round-trips.

const STORAGE_KEY = 'rm_visitor_id'
const TOKEN_REGEX = /^[A-Za-z0-9._-]{8,128}$/

function generate() {
  if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
    return crypto.randomUUID()
  }

  // Fallback for very old browsers — RFC 4122 v4 without the crypto API.
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, c => {
    const r = (Math.random() * 16) | 0
    const v = c === 'x' ? r : (r & 0x3) | 0x8
    
    return v.toString(16)
  })
}

function read() {
  try {
    const v = localStorage.getItem(STORAGE_KEY)
    
    return TOKEN_REGEX.test(v) ? v : null
  } catch {
    return null
  }
}

function write(value) {
  try {
    localStorage.setItem(STORAGE_KEY, value)
  } catch {
    // Safari private mode / quota / disabled storage — degrade silently;
    // the value still lives in module memory for this page lifetime.
  }
}

let visitorId = read()
if (!visitorId) {
  visitorId = generate()
  write(visitorId)
}

export function getVisitorId() {
  return visitorId
}

export const VISITOR_ID_HEADER = 'X-Visitor-Id'
